import React, { useState, useEffect } from "react";
import Select from "react-select";
import {
  createSetting,
  getSetting,
  editSetting,
  publishSetting,
} from "../../api/api";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Loader from "../loader/loader";
import { UserLang } from "../../store/userStore";
import ToolTip from "../tooltip/tooltip";
import { NecStore } from "../../store/necStore";

const Setting = (props) => {
  const initState = {
    title: "",
    headData: "",
    domainName: "",
    startPage: "",
    allowLogin: false,
    allowSubscription: false,
    siteDescription: "",
    bingeWatching: false,
    resumePlayback: false,
    socialSharing: false,
    chromecastID: "",
    rtl: false,
    multiLanguage: false,
    favourites: false,
    watchHistory: false,
    premiumIconVisibility: false,
    premiumIcon: "",
    production: false,
    gdpr: false,
    RFP: false,
    darkMode: false,
  };

  const [colorSchema, setColor] = useState(initState);
  const [colorCount, setColorCount] = useState("");
  const [colorStatus, setColorStatus] = useState(0);
  const [loading, setLoading] = useState(false);
  const lan = UserLang.useState((s) => s.lan);
  const role = NecStore.useState((s) => s.setting);

  const menuPic = [
    {
      value: "Home",
      label: "Home",
    },
    {
      value: "Music",
      label: "Music",
    },
    {
      value: "Star",
      label: "Star",
    },
    {
      value: "Document",
      label: "Document",
    },
    {
      value: "Padlock",
      label: "Padlock",
    },
    {
      value: "Dollar",
      label: "Dollar",
    },
    {
      value: "Crown",
      label: "Crown",
    },
    {
      value: "Audio",
      label: "Audio",
    },
    {
      value: "Profile",
      label: "Profile",
    },
    {
      value: "Bar Menu",
      label: "Bar Menu",
    },
    {
      value: "Dot Menu",
      label: "Dot Menu",
    },
    {
      value: "Bell",
      label: "Bell",
    },
    {
      value: "Video",
      label: "Video",
    },
    {
      value: "Sort",
      label: "Sort",
    },
    {
      value: "Photo",
      label: "Photo",
    },
    {
      value: "Eye",
      label: "Eye",
    },
    {
      value: "Search",
      label: "Search",
    },
    {
      value: "Movie",
      label: "Movie",
    },
    {
      value: "Setting",
      label: "Setting",
    },
    {
      value: "Globe",
      label: "Globe",
    },
    {
      value: "Folder",
      label: "Folder",
    },
    {
      value: "Paint",
      label: "Paint",
    },

    {
      value: "Cast",
      label: "Cast",
    },
    {
      value: "Refresh",
      label: "Refresh",
    },
    {
      value: "Play",
      label: "Play",
    },
    {
      value: "Stop",
      label: "Stop",
    },
    {
      value: "Pause",
      label: "Pause",
    },
    {
      value: "Trash",
      label: "Trash",
    },
    {
      value: "Close",
      label: "Close",
    },
    {
      value: "Back Arrow",
      label: "Back Arrow",
    },
    {
      value: "Forward Arrow",
      label: "Forward Arrow",
    },
    {
      value: "Down Arrow",
      label: "Down Arrow",
    },
    {
      value: "Up Arrow",
      label: "Up Arrow",
    },
    {
      value: "Live",
      label: "Live",
    },
  ];

  /* eslint-disable no-unused-vars */
  const [allIcon, setIcon] = useState(menuPic);

  const handleChange = (evt) => {
    const value = evt.target.value;
    setColor({
      ...colorSchema,
      [evt.target.name]: value,
    });
  };

  const onChangeItemed = (value, evt) => {
    setColor({
      ...colorSchema,
      [evt.name]: value.value,
    });
  };
  const updateVisiblity = (event) => {
    setColor({
      ...colorSchema,
      [event.target.name]: event.target.checked,
    });
  };

  useEffect(() => {
    const colorDetail = async () => {
      setLoading(true);
      /* eslint-disable no-unused-vars */
      const result = await getSetting().then(
        (result) => {
          setColor(result.data);
          setLoading(false);
        },
        (error) => {
          const obj = {
            status: error.response.data.error.status,
            message: error.response.data.error.message,
          };
          setColorCount(obj.message);
          setColorStatus(obj.status);
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    };

    colorDetail();
  }, []);

  const colorSave = async (event) => {
    setLoading(true);
    event.preventDefault();

    if (colorStatus === 404 || colorCount === "No Setting Schema Exists") {
      /* eslint-disable no-unused-vars */
      const result = await createSetting(colorSchema).then(
        (result) => {
          toastr.success("Successfully Saved", "Success");
          setLoading(false);
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    } else {
      const result = await editSetting(colorSchema).then(
        (result) => {
          toastr.success("Successfully Saved", "Success");
          setLoading(false);
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
          setLoading(false);
        }
      );
    }
  };

  const publish = async (event) => {
    // setDisable(true);
    // setLoading(true);
    event.preventDefault();
    if (role.production === true) {
      /* eslint-disable no-unused-vars */
      const result = await publishSetting().then(
        (result) => {
          toastr.success("Successfully Published", "Success");
          // setLoading(false);
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
          // setLoading(false);
        }
      );
    } else {
      toastr.error("Preview Environment is off", "Error");
    }
    /* eslint-disable no-unused-vars */
  };

  if (loading) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h3
                    className={
                      lan === "rtl"
                        ? "card-title float-right"
                        : "card-title float-left"
                    }
                  >
                    Setting Schema
                  </h3>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <form onSubmit={colorSave}>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"allowSubscription"}
                              id={"allowSubscription"}
                              defaultChecked={colorSchema.allowSubscription}
                              onClick={(event) => updateVisiblity(event)}
                            />
                            <label
                              className="custom-control-label not-bold"
                              htmlFor={"allowSubscription"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                              Allow Subscription&nbsp;
                              {
                                // !(lan==="rtl")&&
                                <ToolTip
                                  info={
                                    "Enable this for adding the Subscription to the platform"
                                  }
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              }
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        {/* text input */}
                        <div className="form-group">
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"allowLogin"}
                              id={"allowLogin"}
                              defaultChecked={colorSchema.allowLogin}
                              onClick={(event) => updateVisiblity(event)}
                            />
                            <label
                              className="custom-control-label not-bold"
                              htmlFor={"allowLogin"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                              Allow Login&nbsp;
                              {
                                // !(lan==="rtl")&&
                                <ToolTip
                                  info={
                                    "Enable this for adding the login to the platform"
                                  }
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              }
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"bingeWatching"}
                              id={"bingeWatching"}
                              defaultChecked={colorSchema.bingeWatching}
                              onClick={(event) => updateVisiblity(event)}
                            />
                            <label
                              className="custom-control-label not-bold"
                              htmlFor={"bingeWatching"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                              Binge Watching&nbsp;
                              {
                                // !(lan==="rtl")&&
                                <ToolTip
                                  info={
                                    "Enable this for adding multiple episodes in the player"
                                  }
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              }
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"resumePlayback"}
                              id={"resumePlayback"}
                              defaultChecked={colorSchema.resumePlayback}
                              onClick={(event) => updateVisiblity(event)}
                            />
                            <label
                              className="custom-control-label not-bold"
                              htmlFor={"resumePlayback"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                              Resume Playback&nbsp;
                              {
                                // !(lan==="rtl")&&
                                <ToolTip
                                  info={
                                    "Enable resume playback for the platform"
                                  }
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              }
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"socialSharing"}
                              id={"socialSharing"}
                              defaultChecked={colorSchema.socialSharing}
                              onClick={(event) => updateVisiblity(event)}
                            />
                            <label
                              className="custom-control-label not-bold"
                              htmlFor={"socialSharing"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                              Social Sharing&nbsp;
                              {
                                // !(lan==="rtl")&&
                                <ToolTip
                                  info={
                                    "Enable this for shearing on social media from the platform"
                                  }
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              }
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"rtl"}
                              id={"rtl"}
                              defaultChecked={colorSchema.rtl}
                              onClick={(event) => updateVisiblity(event)}
                              disabled
                            />
                            <label
                              className="custom-control-label not-bold"
                              htmlFor={"rtl"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                              RTL Layout&nbsp;
                              {/* {
            !(lan==="rtl")&&
            <ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>} */}
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"multiLanguage"}
                              id={"multiLanguage"}
                              defaultChecked={colorSchema.multiLanguage}
                              onClick={(event) => updateVisiblity(event)}
                              disabled
                            />
                            <label
                              className="custom-control-label not-bold"
                              htmlFor={"multiLanguage"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                              Multi Language&nbsp;
                              {
                                // !(lan==="rtl")&&
                                <ToolTip
                                  info={
                                    "Enable this for adding multiple languages to the platform"
                                  }
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              }
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"favourites"}
                              id={"favourites"}
                              defaultChecked={colorSchema.favourites}
                              onClick={(event) => updateVisiblity(event)}
                            />
                            <label
                              className="custom-control-label not-bold"
                              htmlFor={"favourites"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                              Favourites&nbsp;
                              {
                                // !(lan==="rtl")&&
                                <ToolTip
                                  info={
                                    "Enable this for adding favourite to the platform"
                                  }
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              }
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"watchHistory"}
                              id={"watchHistory"}
                              defaultChecked={colorSchema.watchHistory}
                              onClick={(event) => updateVisiblity(event)}
                            />
                            <label
                              className="custom-control-label not-bold"
                              htmlFor={"watchHistory"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                              Watch History&nbsp;
                              {
                                // !(lan==="rtl")&&
                                <ToolTip
                                  info={
                                    "Enable this for adding Watch History to the platform"
                                  }
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              }
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"gdpr"}
                              id={"gdpr"}
                              defaultChecked={colorSchema.gdpr}
                              onClick={(event) => updateVisiblity(event)}
                            />
                            <label
                              className="custom-control-label not-bold"
                              htmlFor={"gdpr"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                              GDPR&nbsp;
                              {
                                // !(lan==="rtl")&&
                                <ToolTip
                                  info={
                                    "Enable general data protection regulation(GDPR) for web platform"
                                  }
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              }
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"premiumIconVisibility"}
                              id={"premiumIconVisibility"}
                              defaultChecked={colorSchema.premiumIconVisibility}
                              onClick={(event) => updateVisiblity(event)}
                            />
                            <label
                              className="custom-control-label not-bold"
                              htmlFor={"premiumIconVisibility"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                              Premium Icon Visibility&nbsp;
                              {
                                // !(lan==="rtl")&&
                                <ToolTip
                                  info={
                                    "Enable for display premium icon from the platform"
                                  }
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              }
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"production"}
                              id={"production"}
                              defaultChecked={colorSchema.production}
                              onClick={(event) => updateVisiblity(event)}
                            />
                            <label
                              className="custom-control-label not-bold"
                              htmlFor={"production"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                              Production Environment&nbsp;
                              {
                                // !(lan==="rtl")&&
                                <ToolTip
                                  info={
                                    "To enable or disable production environment"
                                  }
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              }
                            </label>
                          </div>
                        </div>
                      </div>
                      {/* {(lan==="rtl")&&
    <div className="col-sm-6"></div>} */}
                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"darkMode"}
                              id={"darkMode"}
                              defaultChecked={colorSchema.darkMode}
                              onClick={(event) => updateVisiblity(event)}
                            />
                            <label
                              className="custom-control-label not-bold"
                              htmlFor={"darkMode"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                              Enable Dark/Light Mode&nbsp;
                              {
                                // !(lan==="rtl")&&
                                <ToolTip
                                  info={
                                    "Enable for dark/light button visibility"
                                  }
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              }
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"RFP"}
                              id={"RFP"}
                              defaultChecked={colorSchema.RFP}
                              onClick={(event) => updateVisiblity(event)}
                            />
                            <label
                              className="custom-control-label not-bold"
                              htmlFor={"RFP"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                              Request For Publish&nbsp;
                              {
                                // !(lan==="rtl")&&
                                <ToolTip
                                  info={
                                    "Allow Publish only after Admin Approval"
                                  }
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              }
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Enter the title for the platform"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;App Title *&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Enter the title for the platform"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="title"
                            className="form-control inside-form"
                            placeholder="App Title"
                            defaultValue={colorSchema.title}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Enter background image url for website"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Body Background Image *&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Enter Background Image Url for website"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="domainName"
                            className="form-control inside-form"
                            placeholder="Domain Name..."
                            defaultValue={colorSchema.domainName}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Enter the valid Broadcast ID"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Receiver ID (chromecast)&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Enter the valid Broadcast ID"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="chromecastID"
                            className="form-control inside-form"
                            placeholder="chromecastID..."
                            defaultValue={colorSchema.chromecastID}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        {/* text input */}
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Description of the platform"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Site Description *&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Description of the platform"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <textarea
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            name="siteDescription"
                            className="form-control inside-form"
                            placeholder="Site Description"
                            defaultValue={colorSchema.siteDescription}
                            onChange={handleChange}
                            autoComplete="off"
                          ></textarea>{" "}
                        </div>
                      </div>
                      <div className="col-sm-6">
                        {/* text input */}
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Enter header title for the web platform"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Site Head Data *&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Enter header title for the web platform"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <textarea
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            name="headData"
                            className="form-control inside-form"
                            placeholder="Head Data"
                            defaultValue={colorSchema.headData}
                            onChange={handleChange}
                            autoComplete="off"
                          ></textarea>{" "}
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="row">
                          <div
                            className="col-sm-12"
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                          >
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              {lan === "rtl" && (
                                <ToolTip
                                  info={"Premium icon displayed on platform"}
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              )}
                              &nbsp;Premium Icon&nbsp;
                              {!(lan === "rtl") && (
                                <ToolTip
                                  info={"Premium icon displayed on platform"}
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              )}
                            </label>
                            <Select
                              name="premiumIcon"
                              className={
                                lan === "rtl"
                                  ? "form-control inside-select float-right"
                                  : "form-control inside-select float-left"
                              }
                              options={allIcon}
                              onChange={(value, event) =>
                                onChangeItemed(value, event)
                              }
                            ></Select>

                            <div
                              className="row"
                              style={{
                                marginTop: "100px",
                                backgroundColor: "#f2f2f2",
                                marginLeft: "5px",
                              }}
                            >
                              <div
                                className="col-md-6"
                                style={{ marginTop: "20px", marginLeft: "2px" }}
                              >
                                <span>{colorSchema.premiumIcon}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mb-2 mt-2"></div>

                    <div className="row">
                      <div className="col-12">
                        <div
                          className={
                            lan === "rtl"
                              ? "float-left btn-group btn-group-md"
                              : "float-right btn-group btn-group-md"
                          }
                          role="group"
                        >
                          <button
                            type="submit"
                            className="btn btn-primary"
                            style={{ width: "100px", marginRight: "6px" }}
                          >
                            Save
                          </button>
                          <button
                            type="button"
                            onClick={publish}
                            className="btn btn-success"
                            style={{ width: "100px", marginRight: "6px" }}
                            disabled={!role.production === true ? true : false}
                            hidden={!role.production === true ? true : false}
                          >
                            Publish
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                {/* /.card-body */}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
};

export default Setting;
